<template>
  <label>
    <input
      type='checkbox'
      :checked='isChecked'
      @input='emit("update:isChecked", $event.target.checked)'
    >
    <span class='checkmark'><CheckmarkIcon /></span>
    <span class='content'>
      {{ label }}<slot />
    </span>
  </label>
</template>

<script setup>
import CheckmarkIcon from '@/../images/vue/components/checkbox/checkmark_v2.svg?inline';

defineProps({
  isChecked: { type: Boolean, required: true },
  label: { type: String, required: false, default: undefined }
});
const emit = defineEmits(['update:isChecked']);
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/ltr_rtl'
@import 'app/packs/stylesheets/mixins/responsive'

label
  align-items: center
  cursor: pointer
  display: flex

input
  display: none

  &:checked + span.checkmark
    &:before
      background: var(--text-strong)
      border-color: var(--text-strong)

  &:disabled + span.checkmark
    &:before
      background: #eaeaea

span.checkmark
  align-items: center
  display: inline-flex
  flex-shrink: 0
  justify-content: center
  position: relative

  +lte_ipad
    height: rem4(20px)
    width: rem4(20px)

  +gte_laptop
    height: 20px
    width: 20px

  &:before
    background: #ffffff
    border: 1px solid #eaeaea
    box-sizing: border-box
    content: ''
    left: 0
    position: absolute
    top: 0
    transition: background var(--transition-duration), border-color var(--transition-duration)

    +lte_ipad
      border-radius: rem4(3.333px)
      height: rem4(20px)
      width: rem4(20px)

    +gte_laptop
      border-radius: 3px
      height: 20px
      width: 20px

svg
  position: relative
  z-index: 1

  +lte_ipad
    height: rem4(20px)
    width: rem4(20px)

  +gte_laptop
    height: 20px
    width: 20px

span.content
  align-items: baseline
  display: inline-flex
  user-select: none
  gap: inherit // apply gap from styles of parent not if such is set

  +gte_laptop
    white-space: nowrap
</style>
